import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'Common/components/Modals/Modal';
import ModalTitle from 'Common/components/Modals/ModalTitle';
import Button from 'Common/components/Button';
import axios from 'axios';
import { useRecoilState } from 'recoil';
import projectAtom from 'ProjectManager/Project/Common/recoil/project/projectAtom';
import notify from 'Common/utils/notify';
import { toast } from 'react-toastify';
import getProject from 'ProjectManager/Project/Common/api/getProject';
import { pick } from 'lodash';
import archiveProject from 'ProjectManager/Project/Common/api/status/archiveProject';

const ConfirmModal = ({ onClose }) => {
    const [{ id }, setProject] = useRecoilState(projectAtom);

    const [isConfirming, setIsConfirming] = useState(false);

    const source = useMemo(() => axios.CancelToken.source(), []);

    useEffect(
        () => () => {
            source.cancel();
        },
        [source],
    );

    const handleConfirm = async () => {
        setIsConfirming(true);

        try {
            await archiveProject(id, source.token);

            const response = await getProject(id, [], source.token);

            setProject(prevProject => ({
                ...prevProject,
                ...pick(response.data, ['status', 'archivedAt']),
            }));

            setIsConfirming(false);

            onClose();
        } catch (error) {
            if (!axios.isCancel(error)) {
                setIsConfirming(false);

                notify(
                    'Ein Fehler ist aufgetreten. Bitte versuche es erneut.',
                    {
                        type: toast.TYPE.ERROR,
                    },
                );
            }
        }
    };

    return (
        <Modal
            isOpen
            onRequestClose={isConfirming ? undefined : onClose}
            buttons={
                <>
                    <Button
                        text
                        dark
                        type="button"
                        disabled={isConfirming}
                        onClick={onClose}
                    >
                        Abbrechen
                    </Button>
                    <Button
                        type="button"
                        isLoading={isConfirming}
                        disabled={isConfirming}
                        onClick={handleConfirm}
                    >
                        Archivieren
                    </Button>
                </>
            }
        >
            <ModalTitle>Projektarchivierung</ModalTitle>
            <p>
                Bitte bedenke, dass die Archivierung irreversibel und
                unumkehrbar ist. In dem du bestätigst archivierst du das Projekt
                endgültig.
            </p>
        </Modal>
    );
};

ConfirmModal.propTypes = {
    onClose: PropTypes.func.isRequired,
};

export default ConfirmModal;
